import { useEffect, useRef } from 'react'

const marqueeText = 'FRONT — SAAS — CTRL — AI — AUTO — DEPLOYABLE SYSTEMS — 构域矩阵 — '

export function KineticMarquee({ reducedMotion = false, compact = false }) {
  const rootRef = useRef(null)

  useEffect(() => {
    if (reducedMotion) return undefined
    let lastY = window.scrollY
    let skew = 0
    let frame = 0

    const update = () => {
      const velocity = window.scrollY - lastY
      lastY = window.scrollY
      skew += (Math.max(-10, Math.min(10, velocity * 0.08)) - skew) * 0.12
      rootRef.current?.style.setProperty('--marquee-skew', `${skew}deg`)
      frame = requestAnimationFrame(update)
    }
    frame = requestAnimationFrame(update)
    return () => cancelAnimationFrame(frame)
  }, [reducedMotion])

  const content = `${marqueeText}${marqueeText}${marqueeText}`

  return (
    <div
      ref={rootRef}
      className={`kinetic-marquee ${compact ? 'kinetic-marquee--compact' : ''} ${reducedMotion ? 'kinetic-marquee--paused' : ''}`}
      aria-hidden="true"
    >
      <div className="kinetic-marquee__line kinetic-marquee__line--left">
        <span>{content}</span>
        <span>{content}</span>
      </div>
      <div className="kinetic-marquee__line kinetic-marquee__line--right">
        <span>{content}</span>
        <span>{content}</span>
      </div>
    </div>
  )
}
